import { psAxios } from '@patsnap/common-ps-http';
import _ from 'lodash';
import { Message } from '@patsnap/tahiti-core/common/message';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { EXCEED_USAGE_ERROR_CODE } from '@/constants';

export default function initExceedUsageErrorCatch() {
    const messageService = injectService<Message>(Message);

    psAxios.interceptors.response.use(null as any, error => {
        const errorCode = _.get(error, '_error_code');
        // 超出使用容量错误码
        if (errorCode === EXCEED_USAGE_ERROR_CODE) {
            messageService.closeAll();
            messageService.warning({
                message: error._error_msg,
                showClose: true,
            });
        }
        return error.response;
    });
}